// extracted by mini-css-extract-plugin
export default {"guide":"guide_guide__t-t3k","section":"guide_section__TFHwa","codeBlock":"guide_codeBlock__Jbwqo"};